// extracted by mini-css-extract-plugin
export default {"container":"ModalLayout_container__3SBgU","modal":"ModalLayout_modal__SK3jt","title":"ModalLayout_title__toSC8","crossIconContainer":"ModalLayout_crossIconContainer__LPsTV"};